import React from "react";
import { TableRow } from "@mui/material";

const DSTableRow = React.forwardRef<
  HTMLTableRowElement,
  React.ComponentProps<typeof TableRow>
>((props, ref) => {
  return <TableRow ref={ref} {...props} />;
});

DSTableRow.displayName = "DSTableRow";

export default DSTableRow;
